// src/components/LoginModal.jsx
import React from 'react';
import { useLogin } from '../pages/contexts/LoginContext';
import config from '../config';
import { isInWebView } from '../pages/utils';

const LoginModal = () => {
  const {
    showLoginModal,
    setShowLoginModal,
    loginMode,
    setLoginMode,
    email,
    setEmail,
    password,
    setPassword,
    confirmPassword,
    setConfirmPassword,
    handleLoginOrRegister,
    handleGoogleLogin,
  } = useLogin();

  if (!showLoginModal) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 animate-fadeIn"
      onClick={() => setShowLoginModal(false)}
    >
      <div
        className="bg-white rounded-lg p-6 w-full max-w-sm shadow-lg animate-zoomIn"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Tabs */}
        <div className="flex justify-center mb-6">
          <button
            onClick={() => setLoginMode('login')}
            className={`px-4 py-2 text-sm font-medium rounded-t-lg ${
              loginMode === 'login'
                ? 'border-b-2 border-blue-600 text-blue-600'
                : 'text-gray-500'
            }`}
          >
            Login
          </button>
          <button
            onClick={() => setLoginMode('register')}
            className={`px-4 py-2 text-sm font-medium rounded-t-lg ml-4 ${
              loginMode === 'register'
                ? 'border-b-2 border-blue-600 text-blue-600'
                : 'text-gray-500'
            }`}
          >
            Register
          </button>
        </div>

        {/* Form */}
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
              placeholder="you@example.com"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
              placeholder="••••••••"
            />
          </div>

          {loginMode === 'register' && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Confirm Password
              </label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
                placeholder="••••••••"
              />
            </div>
          )}

          {/* Buttons */}
          <div className="flex justify-between mt-4">
            <button
              onClick={() => setShowLoginModal(false)}
              className="px-4 py-2 border rounded text-gray-700"
            >
              Cancel
            </button>
            <button
              onClick={handleLoginOrRegister}
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              {loginMode === 'login' ? 'Login' : 'Register'}
            </button>
          </div>

          {/* Divider */}
          <div className="relative my-4">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-300" />
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="bg-white px-2 text-gray-500">or</span>
            </div>
          </div>

          {/* Google Login */}
          <button
            onClick={handleGoogleLogin}
            className="w-full flex items-center justify-center border border-gray-300 rounded px-4 py-2 text-sm font-medium hover:bg-gray-100"
          >
            <img
              src="https://www.svgrepo.com/show/475656/google-color.svg"
              alt="Google"
              className="w-5 h-5 mr-2"
            />
            Continue with Google
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;